import { render, staticRenderFns } from "./ImportJsonApp.vue?vue&type=template&id=05d0fe2f&scoped=true"
import script from "./ImportJsonApp.vue?vue&type=script&lang=js"
export * from "./ImportJsonApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0fe2f",
  null
  
)

export default component.exports